export default __webpack_public_path__ + "static/media/pagination-left.900bcc44.svg";